export default {
  personal: {
    first: {
      state: '',
      city: '',
      firstPrimerNombre: '',
      firstSegundoNombre: '',
      firstPrimerApellido: '',
      firstSegundoApellido: '',
      relationship: '',
      firstCelular: ''
    },
    second: {
      state: '',
      city: '',
      secondPrimerNombre: '',
      secondSegundoNombre: '',
      secondPrimerApellido: '',
      secondSegundoApellido: '',
      relationship: '',
      secondCelular: ''
    }
  },
  family: {
    first: {
      state: '',
      city: ''
    },
    second: {
      state: '',
      city: ''
    }
  }
}
